import { Injectable } from '@angular/core';
import { MedicoRequest } from '@/core/api/sicom-api/registro/medico/medico.model';

@Injectable({
    providedIn: 'root'
})
/** Lógica pura de mapeamento dos dados de registro (ex.: extração do id de município). */
export class DadosRegistroMapper {
    mapRh(valor?: string): string | undefined {
        if (!valor) return undefined;
        return valor === '+' ? 'POSITIVO' : valor === '-' ? 'NEGATIVO' : undefined;
    }

    mapDoacaoOrgaos(valor?: string): string | undefined {
        if (!valor) return undefined;
        return valor === 'S' ? 'DOADOR' : valor === 'N' ? 'NAO_DOADOR' : undefined;
    }

    mapCategoriaMilitar(valor?: string): string | undefined {
        if (!valor) return undefined;
        const v = valor.toString().trim().toUpperCase();
        if (v === 'C' || v.includes('CIVIL')) return 'C';
        if (v === 'M' || v.includes('MILITAR')) return 'M';
        return undefined;
    }

    unmapRh(valor?: string): string | undefined {
        if (!valor) return undefined;
        return valor === 'POSITIVO' ? '+' : valor === 'NEGATIVO' ? '-' : undefined;
    }

    unmapDoacaoOrgaos(valor?: string): string | undefined {
        if (!valor) return undefined;
        return valor === 'DOADOR' ? 'S' : valor === 'NAO_DOADOR' ? 'N' : undefined;
    }

    extrairMunicipioId(m: MedicoRequest): number | null {
        const anyM = m as {
            municipioIdMunicipio?: unknown;
            municipioidmunicipio?: unknown;
            idMunicipio?: unknown;
            municipioId?: unknown;
            idMunicipioNaturalidade?: unknown;
            naturalidadeIdMunicipio?: unknown;
            idMunicipioNascimento?: unknown;
            municipioNascimentoId?: unknown;
            idMunicipioNasc?: unknown;
            municipioNaturalidadeId?: unknown;
        };
        const candidates = [
            anyM?.municipioIdMunicipio,
            anyM?.municipioidmunicipio,
            anyM?.idMunicipio,
            anyM?.municipioId,
            anyM?.idMunicipioNaturalidade,
            anyM?.naturalidadeIdMunicipio,
            anyM?.idMunicipioNascimento,
            anyM?.municipioNascimentoId,
            anyM?.idMunicipioNasc,
            anyM?.municipioNaturalidadeId
        ];
        for (const c of candidates) {
            if (c !== undefined && c !== null && c !== '') {
                const n = Number(c);
                if (Number.isFinite(n)) {
                    const ni = Math.trunc(n);
                    if (ni > 0) return ni;
                }
            }
        }
        return null;
    }

    formatarData(valor?: string | null): string {
        if (!valor) return '';
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(String(valor))) {
            return String(valor);
        }
        const m = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) {
            const [, yyyy, mm, dd] = m;
            return `${dd}/${mm}/${yyyy}`;
        }
        try {
            const d = new Date(valor);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}/${mm}/${yyyy}`;
        } catch {
            return String(valor);
        }
    }
}
